import React, { useEffect, useRef } from 'react';

const BranchMarkdownDialog = ({
  plan,
  isDarkMode = false,
  isWorking = false,
  onCancel,
  onKeep,
  onReplace,
}) => {
  const cancelButtonRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    cancelButtonRef.current?.focus();
  }, []);

  if (!plan) return null;
  const eligibleCount = plan.eligibleIds.length;
  const excludedCount = plan.excludedIds.length;

  return (
    <div
      className={`branch-markdown-dialog__backdrop${isDarkMode ? ' is-dark' : ''}`}
      onPointerDown={(event) => {
        event.stopPropagation();
        if (event.target === event.currentTarget && !isWorking) onCancel?.();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === 'Escape' && !isWorking) {
          event.preventDefault();
          onCancel?.();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...(dialogRef.current?.querySelectorAll('button:not(:disabled)') || [])];
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }}
      onMouseDown={(event) => {
        event.stopPropagation();
      }}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.stopPropagation()}
    >
      <section
        ref={dialogRef}
        className="branch-markdown-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="branch-markdown-title"
        aria-describedby="branch-markdown-summary"
      >
        <header>
          <div>
            <h2 id="branch-markdown-title">Create Markdown list</h2>
            <p id="branch-markdown-summary">
              {eligibleCount} {eligibleCount === 1 ? 'idea' : 'ideas'} included
              {excludedCount > 0
                ? ` · ${excludedCount} ${excludedCount === 1 ? 'idea' : 'ideas'} excluded and kept on the map`
                : ''}
            </p>
          </div>
          <button
            ref={cancelButtonRef}
            type="button"
            className="branch-markdown-dialog__close"
            aria-label="Close Markdown list preview"
            disabled={isWorking}
            onClick={onCancel}
          >
            ×
          </button>
        </header>

        <div className="branch-markdown-dialog__preview-wrap">
          <div className="branch-markdown-dialog__filename">{plan.filename}</div>
          <pre aria-label="Markdown list preview">{plan.markdown}</pre>
        </div>

        {!plan.replaceAllowed && (
          <p className="branch-markdown-dialog__reason" role="status">
            {plan.replaceDisabledReason}
          </p>
        )}

        <footer>
          <button type="button" disabled={isWorking} onClick={onCancel}>Cancel</button>
          <button type="button" disabled={isWorking} onClick={onKeep}>
            {isWorking ? 'Creating…' : 'Keep ideas'}
          </button>
          <button
            type="button"
            className="branch-markdown-dialog__replace"
            disabled={isWorking || !plan.replaceAllowed}
            title={!plan.replaceAllowed ? plan.replaceDisabledReason : undefined}
            onClick={onReplace}
          >
            {isWorking ? 'Creating…' : 'Replace ideas'}
          </button>
        </footer>
      </section>
    </div>
  );
};

export default BranchMarkdownDialog;
